import { Routes, Route } from "react-router-dom";
import './App.css';
import Navbar from './Navbar';
import Home from './Home';
import Mapa from './Mapa';
import Politica from './Politicas_De_Privacidad';
import Terminos from './Términos_y_Condiciones';
import Tienda from "./Tienda";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navbar />}>
          <Route index element={<Home />} />
          <Route path="Mapa" element={<Mapa />} />
          <Route path="PoliticaPrivacidad" element={<Politica />} />
          <Route path="Terminos" element={<Terminos />} />
          <Route path="/Tienda/:Id"
            loader={({ params }) => {
              //console.log(params.teamId);
            }}
             element={<Tienda />} />
          <Route path="*" element={<></>} />
        </Route>
      </Routes>
    </>
  );
}